"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlainObject = exports.suggestedValues = exports.camelCase = exports.values = exports.keys = exports.mapValues = exports.roundValue = exports.displayCurrency = exports.formatCurrency = exports.startEndDate = exports.hashCode = exports.ObjectId = exports.paginate = void 0;
/**
 * Search product server-side by name or ean
 * @param  {CountrSdk} sdk - Countr sdk obj
 * @param  {string} endpoint - endpoint
 * @returns {Promise<Product[]>}  returns array of products or empty array
 */
const paginate = (countr, endpoint, limit) => __awaiter(void 0, void 0, void 0, function* () {
    const entity = countr[endpoint];
    const count = yield entity.count();
    const entities = [];
    let skip = 0;
    while (entities.length < count) {
        const res = yield entity.read({
            skip,
            limit
        });
        skip += limit;
        entities.push(...res);
    }
    return entities;
});
exports.paginate = paginate;
/**
 * Create string Mongo's ObjectId like
 * @returns {string}
 */
const ObjectId = () => {
    return (Math.floor(Date.now() / 1000).toString(16) +
        ' '.repeat(16).replace(/./g, () => Math.floor(Math.random() * 16).toString(16)));
};
exports.ObjectId = ObjectId;
/**
 * Transform any string to a hash
 * @param  {any} str - string to be transformed
 * @returns {string} hash code of the string
 */
const hashCode = (str) => {
    return str.split('').reduce((a, b) => {
        a = (a << 5) - a + b.charCodeAt(0);
        return a & a;
    }, 0);
};
exports.hashCode = hashCode;
/**
 * Create object from a specific date
 * @param  {Date} now - Input date - default: now
 * @returns {StartEndDate} return obj with iso and local times of one date
 */
const startEndDate = (now = new Date()) => {
    const date = {
        iso: {
            start: () => new Date(now.setHours(0, 0, 0, 0)).toISOString(),
            now: () => now.toISOString(),
            end: () => new Date(now.setHours(23, 59, 59, 999)).toISOString()
        },
        local: {
            start: () => new Date(new Date(now.setHours(0, 0, 0, 0)).toString().split('GMT')[0] + ' UTC').toISOString(),
            now: () => new Date(now.toString().split('GMT')[0] + ' UTC').toISOString(),
            end: () => new Date(new Date(now.setHours(23, 59, 59, 999)).toString().split('GMT')[0] + ' UTC').toISOString()
        }
    };
    return date;
};
exports.startEndDate = startEndDate;
/**
 * Format the currency amount according to the locale
 * @param  {number} amount - Amount to be formated
 * @returns {string} Returns string formated
 */
const formatCurrency = (amount) => {
    const separator = '.';
    // parse amount to float if is not already it
    amount = isNaN(amount) ? parseFloat(amount) : amount;
    amount = isNaN(amount) ? 0 : amount;
    // round amount
    amount = (0, exports.roundValue)(amount, 2);
    // convert to string
    let stringAmount = amount.toString();
    stringAmount.replace(',', separator).replace('.', separator);
    // add decimals after dot if not present
    if (stringAmount.indexOf(separator) < 0) {
        stringAmount += separator + '00';
    }
    else {
        if (stringAmount.indexOf(separator) === stringAmount.length - 2) {
            stringAmount += '0';
        }
    }
    // return result string
    return stringAmount;
};
exports.formatCurrency = formatCurrency;
/**
 * Format the currency amount according to the locale and display with currency sumbol
 * @param  {number} amount - Amount to be formated
 * @param  {string} currency - Currency symbol
 * @returns {string} Returns string formated
 */
const displayCurrency = (amount, currency) => {
    return `${currency} ${(0, exports.formatCurrency)(amount)}`;
};
exports.displayCurrency = displayCurrency;
/**
 * Round the value by trunc according to the number of decimals
 * @param {number} value Value to round
 * @param {number} [decimals] Decimals to keep
 * @returns {number} return trunc amount
 */
const roundValue = (value, decimals) => {
    // parse value to float if is not already it
    value = isNaN(value) ? parseFloat(value) : value;
    value = isNaN(value) ? 0 : value;
    // check decimals value
    decimals = decimals || 2;
    // define roundby value
    const roundby = parseInt(Math.pow(10, decimals), 10);
    // trunc amount
    // value = ~~(value * roundby)/roundby;
    value = parseFloat((value * roundby)).toFixed(0);
    value = (Math.round(value) | 0) / roundby;
    return value;
};
exports.roundValue = roundValue;
const mapValues = (obj, property) => {
    return Object.keys(obj).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: obj[key][property] })), {});
};
exports.mapValues = mapValues;
const keys = (obj) => Object.keys(obj);
exports.keys = keys;
const values = (obj) => {
    return (0, exports.keys)(obj).map((key) => obj[key]);
};
exports.values = values;
const camelCase = (str) => str
    .replace(/\s(.)/g, ($1) => $1.toUpperCase())
    .replace(/\s/g, '')
    .replace(/^(.)/, ($1) => $1.toLowerCase());
exports.camelCase = camelCase;
const suggestedValues = (amount) => {
    let suggestionList = [];
    const n = Math.ceil(amount);
    suggestionList.push(n);
    let x = 1;
    while (suggestionList[suggestionList.length - 1] / 3 < amount) {
        suggestionList.push(n - (n % (2 * x)) + 2 * x);
        suggestionList.push(n - (n % (5 * x)) + 5 * x);
        suggestionList.push(n - (n % (10 * x)) + 10 * x);
        x *= 10;
    }
    // Remove any values not consistent with the main denominations of note
    // (5 or 10, depending on rounded up value)
    suggestionList = suggestionList.filter((obj, index) => {
        if (!(obj % 5 && index > 0) && !(!(n % 5) && !(obj % 5) && obj % 10 && index > 0)) {
            return obj;
        }
        else {
            return false;
        }
    });
    // Return unique array (the first 4 elements)
    return suggestionList
        .filter((v, i, a) => a.indexOf(v) === i)
        .slice(0, 4)
        .sort((a, b) => +(a > b));
};
exports.suggestedValues = suggestedValues;
const isPlainObject = (obj) => {
    const type = typeof obj;
    return (!!obj &&
        type !== 'function' &&
        Object(obj) &&
        Object.prototype.toString.call(obj) !== '[object Array]');
};
exports.isPlainObject = isPlainObject;
